import React from 'react'
import OppBriefSection from "./OppBriefSection";
import SkillFormButton from '../../talent-application/components/SkillFormButton';
import UserImageCircle from '../../../components/UserImageCircle';
import { AuthContext } from '../../../providers/AuthProvider';


export default class OppBriefScopeSection extends OppBriefSection {
    static sectionTitle = 'Deliverables';
    static TranslationKey = 'start_project.contract_deliverables';
    static CompletedField = 'accepted_deliverables_at';
    static contextType = AuthContext;

    scopes = [
        'Total Scope',
        'My Involvement',
    ];

    constructor(props, context) {
        super(props, context);

        this.state = {
            ...this.state,
            activeScope: 'Total Scope'
        }
    }

    render() {
        let project = this.props.opportunity?.project

        if (!project) {
            return <div />
        }

        let groups = project.groupedAllDeliverablesByCategory();

        let scopes = TB.reduce(this.scopes, (result, scope) => {

            let sections = this.renderForScope(project.phases, scope);
            if (sections?.length) {
                result[scope] = sections;
            }

            return result
        }, [])

        return (
            <div className="project-deliverables-overview">

                <div className="text-left pb-6">
                    <p className="text-lg pb-1">Project Assumptions</p>

                    <div className="rich-text-display">
                        <span dangerouslySetInnerHTML={{__html: project.assumptions || 'None Provided'}}/>
                    </div>
                </div>
                <div className="scope-status-btns">
                    {TB.keys(scopes).map(scope => (
                        <div key={TB.camelCase(scope)}
                            onClick={() => this.setState({ activeScope: scope })}
                            className={TB.mapClass("deliverable-scope-btn", {
                                active: this.state.activeScope === scope
                            })}>
                            {scope}
                        </div>
                    ))}
                </div>
                {this.state.activeScope === 'My Involvement' && (
                    <p className="text-bold mt-3 mb-2 text-left">You are involved in the creation of the deliverables listed below:</p>
                )}

                {scopes[this.state.activeScope]}
            </div>
        );
    }

    renderForScope(phases, scope) {
        let scopeSections = phases.map((phase, i) => {
            let deliverables = [...phase.deliverables];

            if (scope === 'My Involvement') {
                let userDisciplineIds = TB.map(this.props.opportunity.disciplines, 'id');

                deliverables = deliverables.filter(deliverable => {
                    return TB.find(deliverable.activities,
                        activity => TB.find(activity.disciplines, discipline => userDisciplineIds.includes(discipline.id))
                    );
                })
            }

            if (!deliverables.length) {
                return null;
            }

            return (
                <div key={`deliverableCategory${i}`} className="deliverable-category-container pt-16">

                    <div className="text-left">
                        <p className="text-sm uppercase text-light-gray6 -mb-1">Phase {i + 1}</p>
                        <p className="deliverable-cat-header mt-0">{phase.name}</p>
                        <p className="text-sm text-light-gray6">Deliverables</p>
                    </div>

                    <hr />

                    {deliverables.map((deliverable, di) => {
                        return (
                            <div key={`category${i}deliverable${di}`} className="deliverable-panel pb-6 lg:pb-0">
                                <p className={TB.mapClass("deliverable-title", {
                                    'active-scope': scope === 'My Involvement'
                                })}>
                                    {deliverable.name}
                                </p>

                                <div className="lg:flex deliverable-details-panel">

                                    <div className="deliverable-section">
                                        {!!deliverable.description?.length && (
                                            <>
                                                <p className="deliverable-section-title">
                                                    {this.trans('description_label')}
                                                </p>
                                                <p className="deliverable-section-description text-[14px]">
                                                    {deliverable.description}
                                                </p>
                                            </>
                                        )}

                                        {!!deliverable.assumptions && (
                                            <>
                                                <p className="deliverable-section-title">
                                                    {/* Assumptions */}
                                                   {this.trans('assumptions_label')}
                                                </p>

                                                <p dangerouslySetInnerHTML={{ __html: deliverable.assumptions }} />
                                            </>
                                        )}

                                        {!!deliverable.skills.length && (
                                            <>
                                                <p className="deliverable-section-title">
                                                    Skills
                                                </p>

                                                <div className="discipline-skills-container skill-importance-container">
                                                    {deliverable.skills.map(skill => (
                                                        <SkillFormButton
                                                            key={skill.name}
                                                            valuePropName={'importance'}
                                                            // className="has-skill"
                                                            disabled={true}
                                                            scoringOptions={laravel.importance_levels}
                                                            skill={skill}
                                                            selected={true}
                                                            onChange={(model) => {
                                                                // console.log(model)
                                                            }}
                                                        />
                                                    ))}
                                                </div>
                                            </>
                                        )}

                                    </div>

                                    <div className="deliverable-section deliverable-section-list">
                                        {deliverable.activities?.length > 0 && (
                                            <p className="deliverable-section-title">
                                                {this.trans('activities_label')}
                                            </p>
                                        )}
                                        {deliverable.activities?.length > 0 && (
                                            <ul>
                                                {deliverable.activities.map((activity, ai) => (
                                                    <li key={`category${i}deliverable${di}activity${ai}`}>
                                                        <div className="-mt-4 pb-5" dangerouslySetInnerHTML={{__html: activity.description}}/>
                                                        <p className="deliverable-section-title mb-4" style={{ marginLeft: -15 }}>
                                                            Roles Involved
                                                        </p>

                                                        <div className={TB.mapClass({
                                                            "divide-y": !this.props.opportunity.is_agency_opp,
                                                            "flex flex-row items-start flex-wrap gap-y-1 gap-x-2" : this.props.opportunity.is_agency_opp
                                                        })}>
                                                            {TB.map(activity.disciplines, activityDiscipline => {
                                                                if (this.props.opportunity.is_agency_opp) {
                                                                    return (
                                                                        <p key={activityDiscipline.id} className="rounded-full bg-wripplePrimaryPaleGreen px-2 border whitespace-nowrap">
                                                                            {activityDiscipline.name}
                                                                        </p>
                                                                    )
                                                                }
                                                                const matchedTeamMember = TB.find(this.props.opportunity.team.members, member => {
                                                                    return TB.find(member.disciplines, ['id', activityDiscipline.id]);
                                                                })
                                                                if (!matchedTeamMember) return null;

                                                                return (
                                                                    <div className="flex gap-3 items-center py-2" key={activityDiscipline.id}>
                                                                        <UserImageCircle user={matchedTeamMember} size={45} className="img-grayscale" hideTooltip={true} />

                                                                        <div className="p-2">
                                                                            <p className="pb-1">{matchedTeamMember.first_name} {matchedTeamMember.last_name.substr(0,1)}. {this.context.auth.id === matchedTeamMember.id && ('(You)')}</p>
                                                                            <p className="rounded-full bg-wripplePrimaryPaleGreen px-2 border inline">
                                                                                {activityDiscipline.name}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            );
        });


        return TB.filter(scopeSections, TB.isDefined);
    }
}